import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface GameState {
  sidebarLocked: string[];
  ndaSigned: boolean;
  badgeActivated: boolean;
  controlSolved: boolean;
  showGameStart: boolean;
  loggedIn: boolean;
  gameFinished: boolean;
  gameStartTime: number | null;
  gameElapsedMinutes: number;
}

interface GameStore extends GameState {
  // Actions
  lockSidebar: (item: string) => void;
  unlockSidebar: (item: string) => void;
  resetSidebarLocked: () => void;
  setNdaSigned: (signed: boolean) => void;
  setBadgeActivated: (activated: boolean) => void;
  setControlSolved: (solved: boolean) => void;
  setShowGameStart: (show: boolean) => void;
  setLoggedIn: (loggedIn: boolean) => void;
  setGameFinished: (finished: boolean) => void;
  startGameTimer: () => void;
  incrementGameTime: () => void;
  getGameTime: () => string;
  resetToInitialState: () => void;
}

const initialState: GameState = {
  sidebarLocked: ['email'],
  ndaSigned: false,
  badgeActivated: false,
  controlSolved: false,
  showGameStart: true,
  loggedIn: false,
  gameFinished: false,
  gameStartTime: null,
  gameElapsedMinutes: 0,
};

export const useGameStore = create<GameStore>()(
  persist(
    (set, get) => ({
  ...initialState,

  lockSidebar: (item) =>
    set((state) => ({
      sidebarLocked: [...state.sidebarLocked, item],
    })),

  unlockSidebar: (item) =>
    set((state) => ({
      sidebarLocked: state.sidebarLocked.filter((locked) => locked !== item),
    })),

  resetSidebarLocked: () =>
    set({
      sidebarLocked: [],
    }),

  setNdaSigned: (signed) =>
    set({
      ndaSigned: signed,
    }),

  setBadgeActivated: (activated) =>
    set({
      badgeActivated: activated,
    }),

  setControlSolved: (solved) =>
    set({
      controlSolved: solved,
    }),

  setShowGameStart: (show) =>
    set({
      showGameStart: show,
    }),

  setLoggedIn: (loggedIn) =>
    set({
      loggedIn,
    }),

  setGameFinished: (finished) =>
    set({
      gameFinished: finished,
    }),

  startGameTimer: () =>
    set({
      gameStartTime: Date.now(),
      gameElapsedMinutes: 0,
    }),

  incrementGameTime: () =>
    set((state) => ({
      gameElapsedMinutes: state.gameElapsedMinutes + 5,
    })),

  getGameTime: () => {
    const state = get();
    const totalMinutes = 180 + state.gameElapsedMinutes;
    const hours = Math.floor(totalMinutes / 60) % 24;
    const minutes = totalMinutes % 60;
    const displayHours = hours % 12 || 12;
    const period = hours < 12 ? 'AM' : 'PM';
    return `${String(displayHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
  },

  resetToInitialState: () =>
    set(initialState),
    }),
    {
      name: 'game-store',
    },
  ),
);
